"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const helpers_1 = require("../../../lib/helpers");
const DrawerToggleButton_1 = __importDefault(require("./DrawerToggleButton"));
const DrawerHeader = (props) => {
    const { children } = props;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps),
        react_1.default.createElement(DrawerToggleButton_1.default, null),
        children));
};
exports.default = withJourney_1.default('j-drawer-header', DrawerHeader);
